import { Button, Grid, Stack, TextInput, TextInputProps } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { ConnectionStatusBadge } from '@/components/deployments/deployment-editor/IntegrationSelection/integrations/ConnectionStatus/ConnectionStatusBadge'
import { useTestConnectionStatus } from '@/components/deployments/deployment-editor/IntegrationSelection/integrations/useTestConnectionStatus'
import { EventDestination } from '@/types/deployment'

type IntegrationInputHandlerProps = TextInputProps & {
  deviceId: string
  source: EventDestination
  isTestButtonDisabled?: boolean
}

export const IntegrationInputHandler = ({
  deviceId,
  source,
  isTestButtonDisabled,
  ...inputProps
}: IntegrationInputHandlerProps) => {
  const { checkConnection, status, errorMessage } = useTestConnectionStatus()

  const handleTestUrl = () => {
    checkConnection({
      deviceId,
      integrationUrl: inputProps.value as string,
      source
    })
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      event.key === 'Enter' &&
      !isTestButtonDisabled &&
      status !== 'pending'
    ) {
      handleTestUrl()
    }
  }

  return (
    <Stack gap="xs">
      <TextInput
        {...inputProps}
        type="url"
        inputContainer={(children) => (
          <Grid gutter="xs">
            <Grid.Col span="auto">{children}</Grid.Col>

            <Grid.Col span="content">
              <Button
                size="sm"
                disabled={isTestButtonDisabled}
                loading={status === 'pending'}
                onClick={handleTestUrl}
              >
                <FormattedMessage id="integrations.testUrl" />
              </Button>
            </Grid.Col>
          </Grid>
        )}
        onKeyDown={handleKeyDown}
      />

      <ConnectionStatusBadge status={status} detail={errorMessage} />
    </Stack>
  )
}
